export enum FormaCobrancaEnum {
  'Débito Online c/c BB' = 1,
  'Repasse' = 2,
  'Repasse Bruto' = 3,
  'Reaplicação' = 4,
  'Poupança' = 5,
  'Cartão de Crédito' = 6,
  'Boleto Bancário' = 7,
  'Débito em Conta CNAB' = 8,
  'Pix via Open Bank' = 9,
  'PIX' = 10
}
